const average = (values) => values.reduce((sum, value) => sum + value, 0) / values.size

module.exports = average



// WEBPACK FOOTER //
// ./src/helpers/average.js